const SERVICE_TYPE = {
  beusable: 1
}

export const IS_PRODUCTION = process.env.NODE_ENV === 'production'
export const SERVICE_CODE = SERVICE_TYPE[process.env.VUE_APP_SERVICE_NAME] || SERVICE_TYPE.beusable
export const HTTP_STATUS = {
  badRequest: 400,
  unauthrized: 401,
  unprocessableEntity: 422
}

export const HTTP_HEADER_SKIP_ERROR = 'Dream-Skip-Error'
export const STORAGE_ITEM = {
  authToken: 'authToken'
}

export const AUTH_COOKIE = {
  name: 'beu_auth',
  expires: 365,
  path: '/'
}

export const UI_TYPE_COOKIE = {
  name: 'ui_type',
  expires: 365,
  path: '/'
}

export const LOCALE_COOKIE = {
  name: 'locale',
  expires: 365,
  path: '/'
}

export const TOKEN_COOKIE = {
  name: '_beu_a_t_s_',
  expires: 365,
  path: '/'
}

export const LOGIN_CHECK_COOKIE = {
  name: '_beu_heatmap_login',
  path: '/'
}

export const LOGIN_FIRST_COOKIE = {
  name: '_beu_heatmap_first_login',
  path: '/'
}

export const BA_LOGIN_CHECK_COOKIE = {
  name: '_beu_journey_login',
  path: '/'
}

export const BEU_HOST_USER_COOKIE = {
  name: '_beu_host_user_open',
  path: '/'
}

if (IS_PRODUCTION) {
  AUTH_COOKIE.domain = '.beusable.net'
  UI_TYPE_COOKIE.domain = '.beusable.net'
  LOCALE_COOKIE.domain = '.beusable.net'
  TOKEN_COOKIE.domain = '.beusable.net'
  LOGIN_CHECK_COOKIE.domain = '.beusable.net'
  LOGIN_FIRST_COOKIE.domain = '.beusable.net'
  BA_LOGIN_CHECK_COOKIE.domain = '.beusable.net'
  BEU_HOST_USER_COOKIE.domain = '.beusable.net'
}

export const CDN_HOST = 'https://dream-cdn.beusable.net'
export const DOCUMENT_TITLE_PREFIX = 'Beusable'
export const OLD_BEUSABLE_HOST = IS_PRODUCTION ? 'https://www.beusable.net' : 'http://localhost:3000'

export const UTM_TAGS = ['source', 'medium', 'campaign', 'term', 'content']
export const CID_TAGS = ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10']
export const CHANNEL_TAGS = ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12', '13', '14', '15', '16', '17']
export const NEW_MOBILE_HEATMAP_STARTDATE = '2021-07-01'

export const NEW_CODE_DEPLOY_DATE = process.env.VUE_APP_NEW_CODE_DEPLOY_DATE || '2022-08-04'
export const NEW_CODE_INFO_LINK = process.env.VUE_APP_NEW_CODE_INFO_LINK || 'https://forum.beusable.net/ko/post/871'

export const SIGNIN_LINK = process.env.VUE_APP_SIGNIN_LINK || 'https://staging-new-home.beusable.net/signin'

export const REPORT_STATE = {
  RUN: 'run',
  STOP: 'stop',
  ERROR: 'error',
  SCHEDULEDRUN: 'scheduledRun',
  ENDBYPVLIMIT: 'endByPvLimit',
  ENDBYANALYSISDATE: 'endByAnalysisDate'
}

export const DEFAULT_TIMEZONE = '+09:00'
export const DEFAULT_TIMEZONE_NAME = 'Asia/Seoul'

export const DEVICE_DESCKTOP = 'desktop'
export const DEVICE_TABLET = 'tablet'
export const DEVICE_PHONE = 'phone'
export const DESKTOP_SCROLL_HEIGHT = 4410
export const MOBILE_SCROLL_HEIGHT = 3217

export const FREQUENCY_HEIGHT = 40

export const FREQUENCY_RANGE = {
  0: -1,
  1: [51, 100],
  2: [11, 50],
  3: [5, 10],
  4: 4,
  5: 3,
  6: 2,
  7: 1
}
